import { render, staticRenderFns } from "./admin-main-template.vue?vue&type=template&id=d8721598"
import script from "./admin-main-template.vue?vue&type=script&lang=js"
export * from "./admin-main-template.vue?vue&type=script&lang=js"
import style0 from "./admin-main-template.vue?vue&type=style&index=0&id=d8721598&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports